module.exports = __webpack_public_path__ + "static/media/1.3a135351.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/hairback/1.png
// module id = 646
// module chunks = 0